module.exports = __webpack_public_path__ + "img/order-finish.16676aca.png";